import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import SingleChoice from './SingleChoice'
import FullName from './FullName'
import Email from './Email'
import DropDown from './DropDown'
import LongText from './LongText'

const WeddingAttendance = () => {


    const yesOrNoData = [
        {
            id: 1,
            label: "بله",
            checked: false
        },
        {
            id: 2,
            label: "خیر",
            checked: false
        },
        {
            id: 3,
            label: "شاید",
            checked: false
        },
    ]


    const numberData = [
        '1',
        '2',
        '3',
        '4',
        '5',
    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'آیا در عروسی ما شرکت خواهی کرد؟'} subHeader={'لطفا به ما اطلاع دهید که آیا می‌توانید به عروسی ما بیایید یا نه.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <SingleChoice header={'آیا می‌توانید شرکت کنید؟'} options={yesOrNoData} />
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'ایمیل'} />
                <DropDown header={'تعداد بزرگسالان:'} options={ numberData} />
                <DropDown header={'تعداد فرزندان:'} options={numberData } />
                <LongText header={'پیام به عروس و داماد'} />
            </Grid>
        </Grid>
    )
}

export default WeddingAttendance
